import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { EmptyList, Loading } from "../../../components";
import { useLazyReferences } from "../hooks";
import { ReferenceCard, SearchReferenceInput } from "../components";
import { parseSearchParams } from "../../../helpers/clean-object";

export const References = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [limit, setLimit] = React.useState(25);
  const [search, { data, loading, fetchMore, error }] = useLazyReferences();

  console.log({ data, loading, error });

  React.useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: {
          ...parseSearchParams(searchParams),
        },
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;

    return data?.references?.results?.length &&
      data?.references?.results?.length > 0 ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {data?.references?.results?.map((reference) => (
          <ReferenceCard
            key={reference?.id}
            id={reference?.id}
            name={reference?.name}
            url={reference?.url}
            imgUrl={reference?.imgUrl}
            reference={reference?.reference}
            lastPrice={reference?.lastPrice}
            lastQuantity={reference?.lastQuantity}
            productsCount={reference?.products?.length || 0}
          />
        ))}
      </div>
    ) : (
      <EmptyList text="Aucune Référence" />
    );
  };

  if (loading) return <Loading />;

  return (
    <div className="main-container">
      <SearchReferenceInput {...parseSearchParams(searchParams)} />

      <div className="mb-4">{renderList()}</div>

      {data?.references?.hasMore && (
        <div className="flex justify-center">
          <button
            className="cursor-pointer inline-flex items-center justify-center px-4 py-2 text-sm text-white bg-primary-600 hover:bg-primary-700 rounded-md transition-colors"
            onClick={() => {
              fetchMore({
                variables: {
                  offset: data?.references?.results?.length,
                  limit,
                  where: {
                    orderByCreatedAt: "DESC",
                  },
                },
              });
            }}
          >
            Charger Plus
          </button>
        </div>
      )}
    </div>
  );
};
